import "./NoListComer.css";

const NoListProv = ({ title, Icon }) => {
  /*Los props van en Titulo y Icono*/
  return (
    <div className="boxnotdatalistprovlealtad">
      <div>
        <Icon className="Nolistprovlistlealtad" />
      </div>
      <div className="boxtittlelisprovlealtad">
        <p className="tittlenotdatalistprovlealtad">{title}</p>
      </div>
      <div className="boxexplainnotdatalistprovlealtad">
        <p className="explainotdatalistprovlealtad">
          No tiene facturas cargadas de este mes.
        </p>
      </div>
    </div>
  );
};

export default NoListProv;
